import React from 'react';
import { SmileIcon, CheckCircleIcon, NetworkIcon, ShieldCheckIcon, ShieldCheck } from 'lucide-react';
export function ImpactSection() {
  const impacts = [{
    icon: SmileIcon,
    number: '500+',
    title: 'Familias acompañadas',
    description: 'en 7 años de trayectoria'
  }, {
    icon: CheckCircleIcon,
    number: '1,500+',
    title: 'Horas de educación',
    description: 'impartidas a familias'
  }, {
    icon: NetworkIcon,
    number: '26,000+',
    title: 'Personas en comunidad',
    description: 'red digital activa'
  }, {
    icon: ShieldCheckIcon,
    number: '3 años',
    title: 'Con Developing Brains',
    description: 'colaboración continua'
  }];
  return <section id="impacto" className="mp-impact-section py-20 px-4 sm:px-6 lg:px-8" style={{
    background: 'linear-gradient(to bottom, #f0f9e8, #ffffff)'
  }} data-id="element-151" data-mp="10s49lw4nfqgp">
      <div className="max-w-6xl mx-auto" data-id="element-152" data-mp="87ma7l8vzhki">
        <h2 className="mp-impact-title text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-153" data-mp="1r5ow31qku7hy">
          Nuestro Impacto
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-154" data-mp="1m6kougn7qju9">
          {impacts.map((impact, index) => <div key={index} className="mp-impact-card bg-white rounded-xl p-6 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-155" data-mp="1hd9g29yubszp" data-mpi={index}>
              <div className="mp-impact-icon inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4" data-id="element-156" data-mp="18cb9bjx0p7df">
                <impact.icon className="mp-impact-icon-svg w-7 h-7 text-primary" data-id="element-157" data-mp="yfyg0n5dwvj7" />
              </div>
              <p className="mp-impact-number" style={{
            fontSize: '32px',
            fontWeight: 800,
            color: '#2d5a1b',
            lineHeight: 1.1,
            marginBottom: '6px'
          }} data-id="element-158" data-mp="thwxc3bvey89">
                {impact.number}
              </p>
              <h3 className="mp-impact-label text-lg font-bold text-dark mb-1" data-id="element-159" data-mp="m4xn33c53rdi">
                {impact.title}
              </h3>
              <p className="mp-impact-sublabel text-sm text-gray-600" data-id="element-160" data-mp="c8ckspri8udd">
                {impact.description}
              </p>
            </div>)}
        </div>
        <div className="text-center" style={{
        margin: '32px 0 40px'
      }} data-id="element-161" data-mp="h7fifp55nybb">
          <div className="mp-trust-badge" style={{
          background: '#f0fae8',
          border: '1.5px solid #7DC920',
          borderRadius: '12px',
          padding: '14px 28px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '10px',
          width: 'fit-content',
          textAlign: 'left'
        }} data-id="element-162" data-mp="14y1nr8nrz4hm">
            <ShieldCheck size={20} color="#2d5a1b" className="shrink-0" data-id="element-163" data-mp="3godq0k525lld" />
            <span style={{
            fontSize: '14px',
            fontWeight: 600,
            color: '#2d5a1b'
          }} data-id="element-164" data-mp="3kontnq5dnzx2">
              Organización 501(c)(3) registrada — donaciones deducibles de
              impuestos
            </span>
          </div>
        </div>
        <div className="max-w-3xl mx-auto mb-10" data-id="element-165" data-mp="3n1rmxkae9pew">
          <img src="https://cdn.magicpatterns.com/uploads/mpjp6avn71b2bdWwPtnP4c/ChatGPT_Image_Aug_4,_2026,_12_18_48_AM.png" alt="Andreina Escalante durante una charla ante familias de la comunidad" className="w-full h-72 object-cover rounded-2xl shadow-lg" data-id="element-166" data-mp="3i2wt7naw2gg0" />
        </div>
        <div className="bg-white/70 rounded-2xl p-8 border-l-4 border-primary shadow-md" data-id="element-167" data-mp="344qf7rpghb79">
          <p className="mp-impact-quote text-xl italic text-dark text-center" data-id="element-168" data-mp="2zbxdlcpaaize">
            "El mayor impacto ha sido acompañar durante siete años a familias
            que buscaban orientación para comprender mejor las necesidades de
            sus hijos"
          </p>
        </div>
      </div>
    </section>;
}